/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { GeneralFieldController } from "./general-field-controller";
import { getEnumValues } from "../utils/get-enum-values";
import { IrAdverseEventGrades } from "../models/generated/graphql";

export class AdverseEventGradeFieldController extends GeneralFieldController {
	override useControlProps(): FlexControlProps {
		const { t } = useTranslation();
		const options = getEnumValues(IrAdverseEventGrades).map((v) => ({
			label: t(v),
			value: v,
		}));

		return {
			controlType: "combo",
			options,
		};
	}
}
